import { useEffect, useState } from 'react';
import database from '../services/database';
import { isElectron } from '../utils/electron';

/**
 * Composant qui initialise la base de données au démarrage de l'application
 * - En Electron : initialise SQLite locale
 * - En navigateur : initialise localStorage
 */
const DatabaseInitializer = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Timeout de sécurité : rendre l'app disponible immédiatement (non-bloquant)
    setIsReady(true);
    
    // Initialiser la base de données en arrière-plan (non-bloquant)
    const initDatabase = async () => {
      try {
        await database.init();
        if (isElectron()) {
          console.log('✅ Application Electron : Base de données SQLite prête (mode offline complet)');
        } else {
          console.log('✅ Application Web : Base de données localStorage prête');
        }
      } catch (err) {
        console.warn('⚠️ Erreur initialisation base de données (non bloquant):', err);
        // En cas d'erreur, on continue quand même (fallback automatique)
      }
    };

    // Initialiser en arrière-plan sans bloquer
    initDatabase();
  }, []);

  // Si pas encore prêt, afficher un loader très court (500ms max)
  if (!isReady) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy-50 to-gold-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-gold-500 mb-4"></div>
          <div className="text-xl font-semibold text-gray-700">
            Chargement...
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default DatabaseInitializer;
